import { render, staticRenderFns } from "./ConfigViewerList.vue?vue&type=template&id=08f95880"
import script from "./ConfigViewerList.vue?vue&type=script&lang=js"
export * from "./ConfigViewerList.vue?vue&type=script&lang=js"
import style0 from "./ConfigViewerList.vue?vue&type=style&index=0&id=08f95880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports